import { render, staticRenderFns } from "./AtomButton.vue?vue&type=template&id=3f947c68&scoped=true"
import script from "./AtomButton.vue?vue&type=script&lang=js"
export * from "./AtomButton.vue?vue&type=script&lang=js"
import style0 from "./AtomButton.vue?vue&type=style&index=0&id=3f947c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f947c68",
  null
  
)

export default component.exports